import './toggle-btn.scss';
import template from './toggle-btn.html';

export default angular
  .module('doxy.settings.toggleBtn', [])
  .component('toggleBtn', {
    template,
    require: {
      ngModel: '^ngModel',
    },
    bindings: {
      withoutText: '<',
      disabled: '<',
      onToggle: '&',
    },
    controller($scope) {
      this.$onInit = () => {
        this.ngModel.$render = () => {
          this.model = this.ngModel.$viewValue;
        };
        $scope.$watch(
          () => {
            return this.model;
          },
          (value) => {
            this.ngModel.$setViewValue(value);
            this.onToggle({ value });
          }
        );
      };
    },
  }).name;
